module.exports = __webpack_public_path__ + "media/images/offers/big_pack-fc6cbfb716d61de7c4612332c2d7e0c4.svg";